<template>
  <!--subPage -->
  <div class="subPage_container">
    <!--등록폼:start-->
    <div class="form_wrap">
      <h3 class="title">{{ $t('mypage.exchange') }}</h3>
      <div class="api_exchange">
        <i class="exc_img"
          ><img :src="getImagePath(regEx)"
        /></i>
        <span class="exc_name">{{regEx}}</span>
        <a>{{ $t('mypage.connectGuide') }}</a>
      </div>
      <div class="exc_ipcopy">
        <div>
          <h5><span>{{regEx}}</span> {{ $t('mypage.copyIP') }}</h5>
          <p>{{ $t('mypage.copyConnectExAPI') }}</p>
        </div>
        <a class="ipcopy" @click="copyText(exchangeIP) ; popupControll(this.$t('popup.copied'))">IP복사</a>
      </div>
      <h3 class="title">API Key</h3>
      <input
        type="text"
        id="api_key"
        name="api_key"
        class="form_input w100"
        value=""
        :placeholder="$t('mypage.enterAPIKEY')"
        @change="setApi($event)"
      />
      <p class="txt_info">{{ $t('mypage.pasteAPIKEY') }}</p>
      <h3 class="title">Secret Key</h3>
      <input
        type="text"
        id="secret_key"
        name="secret_key"
        class="form_input w100"
        value=""
        :placeholder="$t('mypage.enterSecretKey')"
        @change="setSecret($event)"
      />
      <p class="txt_info" >{{ $t('mypage.pasteSecretKey') }}</p>
      <h3 class="title" v-if="regEx =='OKX'">Passphrase</h3>
      <input
        type="text"
        id="secret_key"
        name="secret_key"
        class="form_input w100"
        value=""
        :placeholder="$t('mypage.enterPassphrase')"
        @change="setPass($event)"
        v-if="regEx =='OKX'"
      />
      <!-- OKX 만 API KEY 등록시 필요 -->
      <p class="txt_info" v-if="regEx =='OKX'">{{ $t('mypage.pastePassphrase') }}</p>
      <hr />
      <!-- <h3 class="title">API연동 사용</h3>
      <div class="toggle_chk">
        <p class="subtxt">API 연결 활성화</p>
        <input
          type="checkbox"
          id="apiChk_use"
          name="apiChk_use"
          checked
        /><label for="apiChk_use"></label>
      </div> -->
      <!--등록폼:End-->
    </div>
    <!--//subPage_container :End -->
    <!--//subPage :End -->

    <!--//등록버튼-->
    <div class="btn_bottom_wrap">
      <button type="button" class="btn_primary" @click="sendApiInfo">
        {{ $t('mypage.connectAPI') }}
      </button>
    </div>
  </div>
</template>

<script>
import { encryptCode } from '@/utils/encrypt';
import {sendApiFunc,editApiFunc} from '@/api/regApi';
import { popupControll } from '@/utils/modalText';
import {
  mapMutations,
  mapState
} from 'vuex';
import { copyText } from '@/utils/copy';
export default {
  name: "RegiApi",
  data() {
    return {
      exchangeIP:"",
    }
  },
  props:{
  },
  computed:{
    ...mapState('setApi',['regEx','regApi','regSecret','regPass','edit'])
  },
  created(){
    this.getExchangeIp()
  },
  methods:{
    encryptCode,
    sendApiFunc,
    editApiFunc,
    ...mapMutations('setApi',['setEx','setApiKey','setSecretKey','setPassKey','changeEdit']),
    ...mapMutations("user", ["changeApi", "changeAgree", "changeDelete"]),
    copyText,
    popupControll,
    getExchangeIp(){ // 띄어쓰기 x
      if(this.regEx == "Binance"){
        this.exchangeIP = '15.165.163.146,3.39.132.189,43.202.8.118,17.253.153.125,44.425.8.153,16.176.274.347,44.853.5.228,15.264.546.874,15.245.845.568,44.723.5.215,44.284.8.215,15.254.515.877,15.325.548.47'
      }else if(this.regEx == "Bybit"){
        this.exchangeIP = "43.200.53.91, 43.200.52.222, 13.125.144.218,15.165.163.146,3.39.132.189,43.202.8.118,17.253.153.125,44.425.8.153,16.176.274.347,44.853.5.228,15.264.546.874,15.245.845.568,44.723.5.215,44.284.8.215,15.254.515.877,15.325.548.47"
      }else if(this.regEx == "OKX"){
        this.exchangeIP = "13.124.108.25, 15.164.115.86, 3.39.213.193,15.165.163.146,3.39.132.189,43.202.8.118,17.253.153.125,44.425.8.153,16.176.274.347,44.853.5.228,15.264.546.874,15.245.845.568,44.723.5.215,44.284.8.215,15.254.515.877,15.325.548.47"
      }
    },
    getImagePath(ex){
      if(ex == "Binance Futures"){
        return require(`@/assets/images/exchange/ec_binance.png`);
      }else{
        return require(`@/assets/images/exchange/ec_${ex.toLowerCase()}.png`);
      }
    },
    setSecret(event){
      let encResult = this.encryptCode(event.target.value);
      // console.log("encResult",encResult);
      this.setSecretKey({ secret:encResult})
    },
    setPass(event){
      let encResult = this.encryptCode(event.target.value);
      // console.log("encResult",encResult);
      this.setPassKey({ pass:encResult})
    },
    setApi(event){
      let encResult = this.encryptCode(event.target.value);
      // console.log("encResult",encResult);
      this.setApiKey({ api:encResult})
    },
    sendApiInfo(){
      // console.log(this.regEx,this.regApi,this.regPass,this.regSecret);
      if(this.regEx == "OKX"){
        if(this.regApi == "" || this.regSecret == "" || this.regPass == ""){
          popupControll(this.$t('mypage.enterAll'))
          return;
        }
      }else{
        if(this.regApi == "" || this.regSecret == ""){
          popupControll(this.$t('mypage.enterAll'))
          return;
        }
      }
      this.setEx({exchange:this.regEx});
      if(this.regEx == "OKX"){
          let allInfo = {
            "accessKey":this.regApi,
            "secretKey":this.regSecret,
            "passphrase":this.regPass
          }
          if(this.edit == true){
            this.editApiFunc(this.regEx,allInfo)
            .then((response)=> {
            // console.log('send api res',response);
              if(response.data.isSuccess == true){
                this.changeApi({ state: false });
                this.changeAgree({ state: false });
                this.changeEdit({state:false})
                setTimeout(()=>{
                  window.location.reload();
                  popupControll(this.$t('mypage.successEditAPI'))
                  return(()=>{
                    window.location.reload();
                  })
                },500)
              }
            })
            .catch(()=> {
              return;
            })
          }else{
            this.sendApiFunc(this.regEx,allInfo)
            .then((response)=> {
              // console.log('send api res',response);
              if(response.data.isSuccess == true){
                this.changeApi({ state: false });
                this.changeAgree({ state: false });
                setTimeout(()=>{
                  window.location.reload();
                  popupControll(this.$t('mypage.successRegAPI'))
                  return(()=>{
                    window.location.reload();
                })
              },500)
              }
            })
            .catch(()=> {
              return;
            })
          }
      }else{
        let allInfo = {
          "accessKey":this.regApi,
          "secretKey":this.regSecret
        }
        if(this.edit == true){
            this.editApiFunc(this.regEx,allInfo)
            .then((response)=> {
            // console.log('send api res',response);
              if(response.data.isSuccess == true){
                this.changeApi({ state: false });
                this.changeAgree({ state: false });
                this.changeEdit({state:false})
                setTimeout(()=>{
                  window.location.reload();
                  popupControll(this.$t('mypage.successEditAPI'))
                  return(()=>{
                    window.location.reload();
                  })
                },500)
              }
            })
            .catch(()=> {
              return;
            })
        }else{
          this.sendApiFunc(this.regEx,allInfo)
          .then((response)=> {
            // console.log('send api res',response);
            if(response.data.isSuccess == true){
              this.changeApi({ state: false });
              this.changeAgree({ state: false });
              setTimeout(()=>{
                window.location.reload();
                popupControll(this.$t('mypage.successRegAPI'))
                  return(()=>{
                    window.location.reload();
                })
              },500)
            }
          })
          .catch(()=> {
              return;
            })
        }
      }
    }
  },
};
</script>
